import { useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

/**
 * Persiste o estado da aba ativa no query param da URL (?tab=X).
 * Isso garante que F5 mantenha a aba selecionada.
 *
 * @param {string|number} defaultTab - Valor padrão da aba
 * @param {string} paramName - Nome do query param (padrão: "tab")
 * @returns {[string|number, Function]} - [tab atual, handler para onChange do <Tabs>]
 */
const useTabState = (defaultTab = 0, paramName = "tab") => {
  const history = useHistory();
  const location = useLocation();

  const getInitialTab = () => {
    const params = new URLSearchParams(location.search);
    const raw = params.get(paramName);
    if (raw === null) return defaultTab;
    // Se o default é número, converte; senão mantém string
    return typeof defaultTab === "number" ? parseInt(raw, 10) : raw;
  };

  const [tab, setTab] = useState(getInitialTab);

  const handleTabChange = (_, newValue) => {
    setTab(newValue);
    const params = new URLSearchParams(location.search);
    params.set(paramName, newValue);
    history.replace({ pathname: location.pathname, search: params.toString() });
  };

  // Setter direto para chamadas programáticas (sem o evento _)
  const setTabDirect = (newValue) => {
    setTab(newValue);
    const params = new URLSearchParams(location.search);
    params.set(paramName, newValue);
    history.replace({ pathname: location.pathname, search: params.toString() });
  };

  return [tab, handleTabChange, setTabDirect];
};

export default useTabState;
